import { render, staticRenderFns } from "./permissionDenial.vue?vue&type=template&id=34fd7e13&scoped=true"
import script from "./permissionDenial.vue?vue&type=script&lang=ts"
export * from "./permissionDenial.vue?vue&type=script&lang=ts"
import style0 from "./permissionDenial.vue?vue&type=style&index=0&id=34fd7e13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fd7e13",
  null
  
)

export default component.exports